import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import { TNotification } from '@/types/Notification.types';

export const getNotifications = async (page = 1, limit = 10): Promise<TCustomAxiosResponse<TNotification[]>> => {
  const { data } = await api.get<TCustomAxiosResponse<TNotification[]>>(apiPaths.notifications.root, {
    params: { page, limit },
  });

  return data;
};

export const getUnreadNotificationsCount = async (): Promise<number> => {
  const { data } = await api.get<{ count: number }>(apiPaths.notifications.unreadCount);

  return data.count;
};

export const getNotificationById = async (notificationId: string): Promise<TNotification[]> => {
  const { data } = await api.get<TCustomAxiosResponse<TNotification[]>>(apiPaths.notifications.byId(notificationId));
  const notification = data.data;

  return notification;
};

export const markAllNotificationsAsRead = async (): Promise<string> => {
  const { data } = await api.post(apiPaths.notifications.markAllRead);

  const result = data.data;

  return result;
};

export const sendScreenerReminder = async (): Promise<string> => {
  const { data } = await api.post(apiPaths.notifications.sendScreenerReminder, {
    channels: ['HTTP', 'EMAIL'],
  });

  return data;
};

export const toggleNotificationReadStatus = async (notificationId: string, isRead: boolean): Promise<string> => {
  const { data } = await api.patch(apiPaths.notifications.readStatus(notificationId), { isRead });

  const result = data.data;

  return result;
};

export const toggleMultipleNotificationsReadStatus = async (notificationIds: string[]): Promise<string> => {
  const { data } = await api.post(apiPaths.notifications.markMultipleRead, { notificationIds });

  const result = data.data;

  return result;
};

export const notifyOrgAdminsAboutMissingPeerSupport = async (): Promise<string> => {
  const { data } = await api.post(apiPaths.notifications.reportMissingPeerSupport);

  return data;
};
